// src/store/index.js
import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import authReducer from './slices/authSlice';
import pickleReducer from './slices/pickleSlice';
import orderReducer from './slices/orderSlice';
import cartReducer from './slices/cartSlice';
import deliveryAddressReducer from './slices/deliveryAddressSlice'; // ADD THIS
import rootSaga from './sagas/rootSaga';
import loadingReducer from './slices/loadingSlice';

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: {
    auth: authReducer,
    pickles: pickleReducer,
    orders: orderReducer,
    cart: cartReducer,
    deliveryAddress: deliveryAddressReducer, // ADD THIS LINE
    loading: loadingReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ thunk: false }).concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export default store;